module.exports = __webpack_public_path__ + "img/ICON_3.536caebc.png";